import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  FormControl,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';

@Directive({
  selector: '[requiredCheckbox][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: JbRequiredCheckboxValidator, multi: true}
  ]
})
export class JbRequiredCheckboxValidator implements Validator {
  public validate(c: FormControl): ValidationErrors | any {
    return c.value === false || c.value === null || typeof(c.value) === 'undefined' ? {
      requiredCheckbox: {
        valid: false
      }
    } : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/form/validators/requiredCheckbox.validator.ts